goog.provide("shadow.js.shim.module$src$svg$editor$objects$text_svg");
goog.provide("module$shadow_js_shim_module$src$svg$editor$objects$text_svg");
shadow.js.shim.module$src$svg$editor$objects$text_svg = shadow.js.nativeProvides["src/svg/editor/objects/text.svg"] = shadow$bridge("src/svg/editor/objects/text.svg");
module$shadow_js_shim_module$src$svg$editor$objects$text_svg.default = shadow.js.shim.module$src$svg$editor$objects$text_svg;
